"use client";

import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth } from '@/hooks/auth';
import { useI18n } from '@/lib/I18nProvider';

import {
    faCar,
    faChevronRight,
    faHandshake,
    faLocationPin,
    faRightToBracket,
    faUser
} from "@fortawesome/free-solid-svg-icons";

export default function SiteHomePage() {
    const { t } = useI18n();

    useAuth({
        middleware: 'guest',
        redirectIfAuthenticated: '/dashboard',
    })
    
    return (
        <div className="mt-5">
            <h1 className="title">{t('clientPortal.home.title')}</h1>
            <div className="columns">
                <div className="column">
                    <Link className="box is-flex is-justify-content-space-between is-align-content-center py-5" href="/register/merchant">
                        <p><FontAwesomeIcon icon={faHandshake} />&nbsp;{t('auth.createAccount')}</p>
                        <p className="has-text-primary">
                            <FontAwesomeIcon
                                icon={faChevronRight}
                            />
                        </p>
                    </Link>
                </div>
                <div className="column">
                    <Link className="box is-flex is-justify-content-space-between is-align-content-center py-5" href="/login">
                        <p><FontAwesomeIcon icon={faRightToBracket} />&nbsp;{t('clientPortal.home.signIn')}</p>
                        <p className="has-text-primary">
                            <FontAwesomeIcon
                                icon={faChevronRight}
                            />
                        </p>
                    </Link>
                </div>
            </div>
            <hr style={{backgroundColor: 'lightgrey'}} />
            <p className="has-text-weight-bold">{t('clientPortal.home.whatToday')}</p>
            <br/>
            <Link className="box is-flex is-justify-content-space-between is-align-content-center py-5" href="/request/order" >
                <p><FontAwesomeIcon icon={faCar} />&nbsp;{t('dashboard.action1')}</p>
                <p className="has-text-primary">
                    <FontAwesomeIcon
                        icon={faChevronRight}
                    />
                </p>
            </Link>
            <Link className="box is-flex is-justify-content-space-between is-align-content-center py-5" href="/tracking">
                <p><FontAwesomeIcon icon={faLocationPin} />&nbsp;{t('tracking.title')}</p>
                <p className="has-text-primary">
                    <FontAwesomeIcon
                        icon={faChevronRight}
                    />
                </p>
            </Link>
            <hr style={{backgroundColor: 'lightgrey'}} />
            <div>
                <p className="has-text-weight-bold">{t('clientPortal.home.hiring')}</p>
                <br/>
                <Link className="box is-flex is-justify-content-space-between is-align-content-center py-5" href="/register/driver">
                    <p><FontAwesomeIcon icon={faUser} />&nbsp;{t('clientPortal.home.becomeDriver')}</p>
                    <p className="has-text-primary">
                        <FontAwesomeIcon
                            icon={faChevronRight}
                        />
                    </p>
                </Link>
            </div>
        </div>
    );
}
